export default "__VITE_ASSET__dVsgQV1o__"